module.exports = __webpack_public_path__ + "static/media/SWT_07.bbe696fd.jpeg";